import axios from "axios";
import URL from "../../config/apiUrl";

const API_URL = URL;

// Register user
const register = async (userData) => {
  const response = await axios.post(`${URL}/api-admin/auth/register`, userData);

  return response.data;
};

// Login user
const login = async (userData) => {
  const response = await axios.post(
    `${API_URL}/api-admin/auth/login`,
    userData
  );
  if (response.data && response.data.token) {
    localStorage.setItem(
      "spektorAdminUser",
      JSON.stringify(response.data.token)
    );
  }

  return response.data;
};

// Logout user
const logout = () => localStorage.removeItem("spektorAdminUser");

const authService = {
  register,
  login,
  logout,
};

export default authService;
